import { render, staticRenderFns } from "./FormExamQuestionEdit.vue?vue&type=template&id=51198bd4&"
import script from "./FormExamQuestionEdit.vue?vue&type=script&lang=js&"
export * from "./FormExamQuestionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports